// react
import { type ReactNode, useMemo, useState } from 'react';

// relative
import {
  GlobalAlertContext,
  type GlobalAlertContextValue,
  type GlobalAlertModel,
} from './GlobalAlertContext';

export function GlobalAlertProvider({ children }: { children: ReactNode }) {
  const [alert, setAlert] = useState<GlobalAlertModel | null>(null);

  const value = useMemo<GlobalAlertContextValue>(
    () => ({
      alert,
      showAlert: (nextAlert) => setAlert(nextAlert),
      clearAlert: (ownerId) => {
        setAlert((currentAlert) => {
          if (!currentAlert) {
            return currentAlert;
          }

          if (ownerId && currentAlert.ownerId !== ownerId) {
            return currentAlert;
          }

          return null;
        });
      },
    }),
    [alert],
  );

  return (
    <GlobalAlertContext.Provider value={value}>
      {children}
    </GlobalAlertContext.Provider>
  );
}
